// extracted by mini-css-extract-plugin
module.exports = {"loading":"loader_loading__j20tW","loading06":"loader_loading06__7eG1M"};